<template>
<div style="height:100%;">
    <v-card class="fill-height print" height="100%">
    <v-toolbar
      flat
      height="auto"
      class="elevation-5"
      id="reportCard"
    >
    <v-row>
        <v-col sm="12" md="6" lg="6" xl="6" cols="12" xs="12">
            <v-toolbar-title style="white-space: pre-wrap; word-wrap: break-word;" id="reportHeader">
                <h4>Транзакционный отчет</h4>
                <h6 class="text--disabled no-print">Представляет транзакции за указанный период</h6>
                <h6 class="text--disabled" v-if="startDate && endDate">Период: {{startDate}} - {{endDate}}</h6>
                <h6 class="text--disabled" id="currentSystemCaption" v-if="currentSystem">Система ТК: {{currentSystem}}</h6>

            </v-toolbar-title>
        </v-col>
        <v-spacer/>
        <v-spacer/>
        <v-col class="no-print d-flex flex-row-reverse" sm="12" md="2" lg="2" xl="2" cols="12">
          <DateIntervalForm
            buttonText="Создать"
            buttonIcon="mdi-play"
            v-on:onValidate="CreateReport"
            :isActive="loading"/>
          <!-- <v-btn v-on:click="CreateReport" x-large color="primary">
            <v-icon left class="pr-5 ml-2" x-large>mdi-play</v-icon>
            Сформировать отчет
          </v-btn> -->
        </v-col>
        <v-col class="no-print d-flex flex-row-reverse" sm="12" md="2" lg="2" xl="2" cols="12">
            <v-container id="dropdown-action" class="ma-0 pa-0" >
              <v-overflow-btn
                ref="action_lookup"
                dark
                v-model="selectedAction"
                x-large
                color="primary "
                background-color="primary"
                class="elevation-1 primary pl-1  "
                :items="exportButtonActions"
                :value="exportButtonActions[0]"
                segmented
                :prepend-icon="actionIcon"
                hide-details=""
                target="#dropdown-action"
                id="action_lookup"
                v-bind:disabled="loading || reportData.length === 0"
              >
              <template v-slot:item="{item }">
                                  <a  v-if="item.text === 'Печать'" class="v-btn__content px-auto" @click="selected = true"  onclick="window.print()">{{item.text}}</a>
                  <a  v-else class="v-btn__content px-auto" @click="selected = true" :download="'TransactionReport_' + new Date().toLocaleDateString('ru-RU', {year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit'}) + '.xls'"
                    onclick="try {return ExcellentExport.excel(this, 'data_table', 'Транзакционный отчет');} catch{alert('Невозможно скачать пустой отчет.')}">
                    {{item.text}}
                  </a>

              </template>
              <template v-slot:selection="{item, selected}">
                  <a  v-if="item.text === 'Печать'" class="v-btn__content" @click="selected = true"  onclick="window.print()">{{item.text}}</a>
                  <a  v-else class="v-btn__content" @click="selected = true" :download="'TransactionReport_' + new Date().toLocaleDateString('ru-RU', {year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit'}) + '.xls'"
                    onclick="try {return ExcellentExport.excel(this, 'data_table', 'Транзакционный отчет');} catch{alert('Невозможно скачать пустой отчет.')}">
                    {{item.text}}
                  </a>
              </template>
              </v-overflow-btn>
            </v-container>
          <!-- <v-btn
          color="primary"
          dark
          block
          x-large
          @click="printDocument"
        >
        <v-icon x-large  left class="pr-5 ml-2">mdi-printer</v-icon>
          Печать
        </v-btn> -->
        </v-col>
    </v-row>
    </v-toolbar>
    <v-card-title>
      <v-row>
        <v-col>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск.."
            class="no-print"
            v-bind:disabled="loading"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-select multiple  clearable v-bind:disabled="loading"  label="Выбор карт" class="no-print"  :items="columnValueList('cardNumber')" v-model="filters.cardNumber">
            <template v-slot:prepend-item>
              <v-list-item
                @click="toggleAll"
              >
              <v-list-item-action>
                <v-icon >
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{selectAllText}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip small color="primary" v-if="index < 2">
                <span>{{ item }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="text--disabled"
              >
                ( +{{ Array.from(new Set(filters.cardNumber)).length - 2 }} других  )
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text style="padding:0px;">
       <v-skeleton-loader
            v-if="loading"
            style="height:100%"
            type="table"
            tile
            class="no-print"
          >
          </v-skeleton-loader>
        <div v-else class="fill-height">
          <v-data-table
            class="dataTable"
            hide-default-footer
            disable-pagination
            :search="search"
            :headers="headers"
            :items="filteredTransaction"
            style="margin-bottom:50px;"
            :items-per-page="0"
            sort-by="transactionDateTime"
            :sort-desc="false"
          >
          <template slot="body.append">
            <tr class="data-table-footer">
                <th class="text-subtitle-1 font-weight-black" colspan="0">Итого:</th>
                <th class="text-subtitle-1 font-weight-black" colspan="0">&Sigma; {{filteredTransaction.length}}</th>
                <th class="text-subtitle-1 font-weight-black empty-field" colspan="0"></th>
                <th class="text-subtitle-1 font-weight-black empty-field" colspan="0"></th>
                <th class="text-subtitle-1 font-weight-black">{{ sumField('value').toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '$& ') }} л.</th>
                <th class="text-subtitle-1 font-weight-black pr-0">{{ sumField('sum').toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '$& ') }} руб.</th>
            </tr>
          </template>
         <template v-slot:group.header="{items, isOpen, toggle}">
            <th colspan="6" class="group_header">
              <v-icon @click="toggle"
                >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
              </v-icon>
              Номер карты: {{ items[0].cardNumber }}
            </th>
          </template>
          <!-- <template v-slot:item.actions="{ item }">
            <EditDeviceForm
            v-bind:item="item"
             v-on:onValidate="UpdateData"/>
          </template>-->
          <template v-slot:item.transactionDateTime="{ item }">
            {{new Date(item.transactionDateTime).toLocaleDateString('ru-RU', {month:'short', day:'numeric', year:'2-digit', hour:'2-digit', minute:'2-digit'})}}
          </template>
          </v-data-table>
        </div>
    </v-card-text>
    </v-card>

</div>
</template>
<script>
import DateIntervalForm from '../../components/DateIntervalForm.vue'
import { mapState, mapActions } from 'vuex'
import ExcellentExport from 'excellentexport'
export default {
  methods: {
    ...mapActions('transactions', {
      getPetrolReport: 'getPetrolReport',
      getOpti24Report: 'getOpti24Report',
      getShellReport: 'getShellReport',
      getNesteReport: 'getNesteReport',
      getRosneftReport: 'getRosneftReport',
      clearData: 'clearData'
    }),
    sumField (key) {
      // sum data in give key (property)
      return this.filteredTransaction.reduce((a, b) => a + (b[key] || 0), 0)
    },
    printDocument () {
      window.print()
    },
    LoadDataFromExcel () {
      return ExcellentExport.excel(this, 'dataTable', 'testTable')
    },
    toggleAll () {
      this.$nextTick(() => {
        if (this.isToggleAll) {
          this.filters.cardNumber = []
        } else {
          this.filters.cardNumber = Array.from(new Set(this.columnValueList('cardNumber'))).slice()
        }
      })
    },
    CreateReport (dataResult) {
      this.currentSystem = dataResult.currentSystem
      switch (dataResult.currentSystem) {
        case 'ППР': this.loadPetrolReport(dataResult); break
        case 'Опти24': this.loadOpti24Report(dataResult); break
        case 'Shell': this.loadShellReport(dataResult); break
        case 'Neste Oil': this.loadNesteReport(dataResult); break
        case 'Роснефть': this.loadRosneftReport(dataResult); break
      }
    },
    loadOpti24Report (data) {
      const sendDate = {
        startDate: data.dateStart,
        endDate: data.dateEnd
      }
      this.getOpti24Report(sendDate)

      this.startDate = new Date(data.dateStart).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
      this.endDate = new Date(data.dateEnd).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
    },
    loadShellReport (data) {
      const sendDate = {
        startDate: data.dateStart,
        endDate: data.dateEnd
      }
      this.getShellReport(sendDate)

      this.startDate = new Date(data.dateStart).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
      this.endDate = new Date(data.dateEnd).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
    },
    loadNesteReport (data) {
      const sendDate = {
        startDate: data.dateStart,
        endDate: data.dateEnd
      }
      this.getNesteReport(sendDate)

      this.startDate = new Date(data.dateStart).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
      this.endDate = new Date(data.dateEnd).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
    },
    loadRosneftReport (data) {
      const sendDate = {
        startDate: data.dateStart,
        endDate: data.dateEnd
      }
      this.getRosneftReport(sendDate)

      this.startDate = new Date(data.dateStart).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
      this.endDate = new Date(data.dateEnd).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
    },
    loadPetrolReport (data) {
      const sendDate = {
        startDate: data.dateStart,
        endDate: data.dateEnd,
        token: this.user.petrolToken
      }
      this.getPetrolReport(sendDate)

      this.startDate = new Date(data.dateStart).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })
      this.endDate = new Date(data.dateEnd).toLocaleDateString('ru-RU', { month: 'numeric', day: 'numeric', year: 'numeric' })

      // load petrol data
      // draw to table
    },
    columnValueList (val) {
      return this.reportData.map(d => d[val])
    }
  },
  watch: {
    filteredTransaction: function () {
      this.$nextTick(() => {
        document.querySelector('table').id = 'data_table'
      })
    }
  },
  computed: {
    ...mapState({
      loading: state => state.transactions.transactionsLoading,
      user: state => state.users.user,
      reportData: state => state.transactions.reportTransactions
    }),
    actionIcon () {
      if (this.selectedAction === 'Печать') return 'mdi-printer'
      else return 'mdi-download'
    },
    icon () {
      if (this.isToggleAll) return 'mdi-close-box'
      if (this.likesSomeCard) return 'mdi-checkbox-blank-outline'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllText () {
      if (this.isToggleAll) return 'Убрать все'
      if (this.likesSomeCard) return 'Выбрать все'
      return 'Выбрать все'
    },
    isToggleAll () {
      return this.filters.cardNumber.length === Array.from(new Set(this.columnValueList('cardNumber'))).length
    },
    likesSomeCard () {
      return this.filters.cardNumber.length > 0 && !this.isToggleAll
    },
    filteredTransaction () {
      return this.reportData.filter(d => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f])
        })
      })
    }
  },
  mounted () {
    document.title = 'Транзакционный отчет - ATK Web'
    this.selectedAction = this.exportButtonActions[0].text
  },
  data: () => ({
    _this: this,
    startDate: null,
    endDate: null,
    selectedAction: '',
    exportButtonActions: [
      { text: 'Печать', callback: () => window.print() },
      { text: 'Скачать', callback: () => alert('Download Excel') }
    ],
    currentSystem: '',
    search: '',
    headers: [
      { text: 'Дата/Время', value: 'transactionDateTime', groupable: false },
      {
        text: 'Бренд АЗС',
        align: 'start',
        sortable: false,
        value: 'brand',
        group: true
      },
      { text: 'Номер карты', value: 'cardNumber', groupable: true },
      { text: 'Марка топлива', value: 'serviceType', groupable: false },
      { text: 'Заправлено', value: 'value', groupable: false },
      { text: 'Сумма (руб.)', value: 'sum', groupable: false }
    ],
    filters: {
      cardNumber: []
    },
    pagination: {
      sortBy: 'name'
    },
    dialog: false
  }),
  components: {
    DateIntervalForm
  }
}
</script>
<style>

  #dropdown-action > div > div.v-input__control > div > div.v-select__slot > div.v-select__selections > button > span {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      font-weight: 500;
      letter-spacing: 0.0892857143em;
      text-indent: 0.0892857143em;
      text-transform: uppercase;
      font-size: 1rem;
  }
  @media screen and (max-width: 600px) {
    .data-table-footer{
      display: initial;
      font-size: 0.225em;
    }
    .empty-field{
      display: none;
    }
  }

  @media print {

    #data_table > thead > tr > th > div{
      display:none;
      -webkit-print-color-adjust: economy;
    }
    .no-print{
      -webkit-print-color-adjust: economy;
      display:none;
    }
    #reportHeader > *{
      -webkit-print-color-adjust: economy;
      color: black !important;
      align-content: center;
      text-align: center;
      vertical-align: middle;
      padding: 0;
      margin: auto;
    }
    #currentSystemCaption{
      text-align: end;
      -webkit-print-color-adjust: economy;
    }

    .group_header{
      background:rgb(214, 214, 214);
      -webkit-print-color-adjust: economy;
    }
    .dataTable table tbody tr {
      color: black !important;
      border-bottom: solid 1px black !important;
      -webkit-print-color-adjust: economy;
    }
    .dataTable table th {
      color: black !important;
      -webkit-print-color-adjust: economy;
    }
    .dataTable table thead tr{
      border-bottom: solid 2px black !important;
      -webkit-print-color-adjust: economy;
    }
  }
</style>
